/**
 * 📋 TABLE WIDGET
 * ════════════════════════════════════════════════════════════════════════
 * 
 * Renderiza tablas de detalle (DETAIL, última posición).
 * Simple, sin lógica adicional.
 */

import React from 'react';
import VirtualizedTable from '../../../../shared/ui/VirtualizedTable';
import { formatTableCellValue } from '../../../../shared/utils/formatters';
import { getTableColumnsCache } from '../../../../shared/utils/seriesCache';
import { DataPoint } from '../../../../types/dashboard';

interface TableWidgetProps {
  widget: {
    id: string;
    title: string;
    data: DataPoint[];
    metadata?: any;
  };
}

const TableWidget: React.FC<TableWidgetProps> = ({ widget }) => {
  
  // Detectar columnas del primer registro
  const columns = getTableColumnsCache(widget.id, widget.data);
  
  return (
    <div className="table-widget">
      {/* Título */}
      <div className="table-title">
        {widget.title}
        {widget.data.length > 0 && (
          <span className="table-count">{widget.data.length} registros</span>
        )}
      </div>
      
      {/* Tabla */}
      <VirtualizedTable
        columns={columns}
        data={widget.data}
        formatCellValue={formatTableCellValue}
        formatHeader={formatColumnName}
        maxCellLength={80}
        rowHeight={38}
        overscan={35}
        containerClassName="table-container"
        tableClassName="data-table"
      />
    </div>
  );
};

/**
 * Formatear nombre de columna
 */
function formatColumnName(col: string): string {
  return col
    .replace(/_/g, ' ')
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export default TableWidget;
